import { useState, useEffect, useRef } from 'react';

const Hero = () => {
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const fullText = 'Turn Ideas Into Visual';
  const timeoutRef = useRef(null);

  useEffect(() => {
    const speed = isDeleting ? 50 : 100;
    
    const updateText = () => {
      setDisplayText(prev => {
        if (!isDeleting) {
          if (prev.length < fullText.length) {
            return fullText.slice(0, prev.length + 1);
          } else {
            timeoutRef.current = setTimeout(() => setIsDeleting(true), 2000);
            return prev;
          }
        } else {
          if (prev.length > 0) {
            return fullText.slice(0, prev.length - 1);
          } else {
            setIsDeleting(false);
            return prev;
          }
        }
      });
    };

    timeoutRef.current = setTimeout(updateText, speed);
    
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [displayText, isDeleting]);

  return (
    <section className="flex min-h-[60vh] sm:min-h-[70vh] flex-col items-center justify-center px-4 py-12 sm:py-20 text-center">
      <div className="max-w-6xl w-full space-y-6 sm:space-y-8">
        <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 sm:px-4 py-1.5 animate-fade-in-down">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary"></span>
          </span>
          <span className="text-xs font-medium uppercase tracking-widest text-primary">Engine v2.0 Online</span>
        </div>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black leading-tight tracking-tight text-white animate-fade-in-up delay-200" style={{ animationFillMode: 'both' }}>
          <span className="typewriter-text">{displayText}</span>
          <span className="typing-cursor">|</span>
          <br />
          <span className="shimmer-text">Reality</span>
        </h1>
        <p className="mx-auto max-w-2xl text-base sm:text-lg md:text-xl text-white/70 animate-fade-in-up delay-400 px-2" style={{ animationFillMode: 'both' }}>
          The ultimate AI creative suite. Generate professional-grade{' '}
          <span className="text-primary">Images, Video, VFX,</span> and{' '}
          <span className="text-primary">3D Models</span> in seconds.
        </p>
      </div>
    </section>
  );
};

export default Hero;
